export default "__VITE_PUBLIC_ASSET__a4e93c2e__"